import { ViteReactSSG } from "vite-react-ssg";
import type { RouteRecord } from "vite-react-ssg";
import { routes } from "./App";
import { AUTH_IMMEDIATE_PATHS } from "./lib/authPaths";
import "./index.css";

const AUTH_PATHS = new Set<string>(AUTH_IMMEDIATE_PATHS);

function normalizeRoutePath(p: string): string {
  if (p === "/" || p === "*") return p;
  return p.startsWith("/") ? p : `/${p}`;
}

/** Geen statische HTML voor auth/admin — SPA fallback, minder crawl-ruis. */
export function includedRoutes(
  paths: string[],
  _routeRecords: Readonly<RouteRecord[]>,
) {
  return paths.filter((p) => {
    if (p.includes(":") || p === "*" || p.includes("*")) return false;
    return !AUTH_PATHS.has(normalizeRoutePath(p));
  });
}

export const createRoot = ViteReactSSG({ routes });
